import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/giveaway/giveaway').then(m => m.GiveawayComponent)
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
